import { useCallback } from 'react';

import { usePintoCreateAnnouncementNotificationMutation } from '../core/graphql/operation-hooks';
import { CreatePintoAnnouncementNotificationInput } from '../core/graphql/types';

const useMutationPintoAnnouncementNotification = () => {
  const [mutatePintoCreateNoti, { loading: isLoadingMutatePintoCreateNoti }] = usePintoCreateAnnouncementNotificationMutation({ errorPolicy: 'all' });

  const onMutatePintoCreateAnnouncementNotification = useCallback(
    async (input: CreatePintoAnnouncementNotificationInput) => {
      const variables = { input };
      const result = await mutatePintoCreateNoti({ variables, refetchQueries: ['PintoAnnouncementNotifications'] });

      if (result.errors) {
        return { success: false, errors: result.errors };
      } else {
        return { success: true, data: result.data };
      }
    },
    [mutatePintoCreateNoti],
  );

  return {
    onMutatePintoCreateAnnouncementNotification,
    isLoadingMutatePintoCreateNoti,
  };
};

export default useMutationPintoAnnouncementNotification;
